import {
  BUYER,
  LOCAL_STORAGE_ROLES,
  ROLE_ASSET_MANAGER,
  ROLE_BOA,
  ROLE_BUYER,
  ROLE_CONSULTANT,
  ROLE_C_ADMIN,
  ROLE_GUEST,
  ROLE_INDIVIDUAL,
  ROLE_SELLER,
  ROLE_SUPER_ADMIN,
  SELLER,
} from "./constant";

export const base64Decode = str => {
  return decodeURIComponent(escape(window.atob(str)));
};

export const base64Encode = str => {
  return window.btoa(unescape(encodeURIComponent(str)));
};

export const page360Url = obj => {
  const pathname = `/eqn-assets/${encodeURIComponent(
    obj.assetCategoryClass?.name,
  )}/${encodeURIComponent(obj.category?.name)}/${encodeURIComponent(
    obj.make?.name,
  )}/${encodeURIComponent(obj.model?.name)}/${obj.enNumber}`;

  return pathname;
};

export const Decimal = number => {
  if (!isNaN(number)) return Number.parseFloat(number).toFixed(2);
  return null;
};

export const getRole = () => {
  let role = "";

  if (
    localStorage.getItem("user") &&
    localStorage.getItem(LOCAL_STORAGE_ROLES)
  ) {
    const roles = localStorage.getItem(LOCAL_STORAGE_ROLES);

    const user = JSON.parse(localStorage.getItem("user"));

    if (user.isIndividual) {
      role = ROLE_INDIVIDUAL;
    }

    if (roles.indexOf(ROLE_BUYER) > -1) {
      role = BUYER;
    }

    if (roles.indexOf(ROLE_SELLER) > -1) {
      role = SELLER;
    }

    if (roles.indexOf(ROLE_C_ADMIN) > -1) {
      role = role + " (Company Admin)";
    }

    if (roles.indexOf(ROLE_ASSET_MANAGER) > -1) {
      role = "Asset Manager";
    }

    if (roles.indexOf(ROLE_BOA) > -1) {
      role = "Back Office Admin";
    }

    if (roles.indexOf(ROLE_SUPER_ADMIN) > -1) {
      role = "Super Admin";
    }
  }

  return role;
};

export const setBuyerSellerName = (obj, seller, currentUser, isChipShown) => {
  if (obj?.id === currentUser?.id) {
    return { name: obj?.displayName, isReasonVisible: true };
  } else if (currentUser?.currentOrganization && obj?.currentOrganization) {
    if (
      seller?.id === obj?.id &&
      currentUser?.currentOrganization?.id !== obj?.currentOrganization?.id
    ) {
      return {
        name: `SELLER-${obj?.id.slice(obj?.id.length - 6)}`,
        isReasonVisible: false,
      };
    }

    const org = obj?.userOrg?.find(
      ob => ob.organization.id === currentUser?.currentOrganization?.id,
    );

    if (org) {
      const role = org.roles.map(role => role.key);

      if (isChipShown || org) {
        return { name: obj?.displayName, isReasonVisible: false };
      }

      if (
        role.length > 0 &&
        role?.some(val => val === ROLE_SELLER || val === ROLE_BUYER)
      ) {
        return {
          name: `BUYER-${obj?.id.slice(obj?.id.length - 6)}`,
          isReasonVisible: false,
        };
      }

      return {
        name: `GUEST-${obj?.id.slice(obj?.id.length - 6)}`,
        isReasonVisible: false,
      };
    }
  }

  if (currentUser?.roles?.find(role => role.key === ROLE_ASSET_MANAGER)) {
    return { name: obj?.displayName, isReasonVisible: true };
  }

  return { name: obj?.displayName, isReasonVisible: false };
};

export const renderNameAndRole = item => {
  if (item) {
    if (item.roles.findIndex(val => val?.key === ROLE_C_ADMIN) > -1)
      return `${item.organization.name} (Company Admin)`;
    if (item.roles.findIndex(val => val?.key === ROLE_BUYER) > -1)
      return `${item.organization.name} (${ROLE_BUYER})`;
    if (item.roles.findIndex(val => val?.key === ROLE_SELLER) > -1)
      return `${item.organization.name} (${ROLE_SELLER})`;
    if (item.roles.findIndex(val => val?.key === ROLE_GUEST) > -1)
      return `${item.organization.name} (${ROLE_GUEST})`;
    if (item.isIndividual)
      return `${item.organization.name} (${ROLE_INDIVIDUAL})`;
    if (item.roles.findIndex(val => val?.key === ROLE_CONSULTANT) > -1)
      return `${item.organization.name} (${ROLE_CONSULTANT})`;
  }
};
